var map = {
	"./Card-24.svg": 1617,
	"./account-24.svg": 1618,
	"./activity-member-24.svg": 1619,
	"./advanced-24.svg": 1620,
	"./dashboards-24.svg": 1621,
	"./folder-closed-24.svg": 1622,
	"./folder-opened-24.svg": 1623,
	"./individual-24.svg": 1624,
	"./integrations-24.svg": 1625,
	"./page-24.svg": 1626,
	"./performance-24.svg": 1627,
	"./security-24.svg": 1628,
	"./settings-24.svg": 1629,
	"./share-24.svg": 1630,
	"./summary-results-24.svg": 1631,
	"./survey-management-24.svg": 1632,
	"./team-24.svg": 1633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1616;